export default class UndoStack{
  constructor(canvas, maxStackSize, canvasState) {
    this.canvas = canvas;
    this.stack = [];
    this.stackPtr = -1;
    this.maxStackSize = maxStackSize || 50;

    // Store whether we can undo/redo here
    this.canvasState = canvasState || {};
    this.canvasState.canUndo = false;
    this.canvasState.canRedo = false;
  }

  _renderState(state){
    if (state.blocks) {
      this.canvasState.blocks = state.blocks;
    }
    this.canvas.loadFromJSON(JSON.stringify(state), () => {
      this.canvas.renderAll();
    });
  }

  // returns whether we canUndo
  // after a push, implicitly canRedo == false
  push(){
    // 'brandly' is an additional propertyToInclude. Used to save brandly custom props including "isPlaceholder"
    const obj = this.canvas.toJSON(['brandly']);
    // Include a deep copy of the block state
    obj.blocks = JSON.parse(JSON.stringify(this.canvasState.blocks));

    if (this.stackPtr < 0 || JSON.stringify(this.stack[this.stackPtr]) !== JSON.stringify(obj)){
      this.stack = this.stack.splice(0, ++this.stackPtr);
      this.stack.push(obj);
      if (this.stack.length > this.maxStackSize){
        // console.log('exceeded max stack size');
        this.stack = this.stack.splice(1, this.maxStackSize);
        this.stackPtr--;
      }
      this.canvasState.canUndo = this.stack.length > 1;
    } else {
      this.canvasState.canUndo = false;
    }
  }

  //implicitly canRedo == true
  //returns canUndoAgain?
  undo(){
    if (this.stackPtr > 0){
      const state = this.stack[--this.stackPtr];
      this._renderState(state);
      this.canvasState.canUndo = this.stackPtr > 0;
      this.canvasState.canRedo = true;
    } else {
      // error state: should not hit this, if UI respects the canvasState.canUndo
      console.log('UndoStack cannot undo');
    }
  }

  //implicitly, canUndo == true
  //returns canRedoAgain?
  redo(){

    if (this.stackPtr + 1 < this.stack.length){
      const state = this.stack[++this.stackPtr];
      this._renderState(state);

      this.canvasState.canUndo = true;
      this.canvasState.canRedo = this.stackPtr + 1 < this.stack.length;
    } else {
      //error state: should not hit this
      console.log('UndoStack cannot redo');
    }
  }


}



// WEBPACK FOOTER //
// ./src/lib/UndoStack.js